import {
  FONT_SIZES,
  FONT_TYPES_MAP,
  SELECTABLE_FONT_TYPE,
} from '@app/components/TextField/constants';

export type DateFormatPart =
  | {
      type: 'SEPARATOR';
      value: string;
      displayText: string;
    }
  | {
      type: 'SUFFIX';
      value: {
        yearSuffix: string;
        monthSuffix: string;
        daySuffix: string;
      };
      displayText: string;
    };

export const DATE_FORMAT_PARTS: Array<DateFormatPart> = [
  {
    type: 'SEPARATOR',
    value: '-',
    displayText: '-',
  },
  {
    type: 'SEPARATOR',
    value: '/',
    displayText: '/',
  },
  {
    type: 'SEPARATOR',
    value: '.',
    displayText: '.',
  },
  {
    type: 'SUFFIX',
    value: {
      yearSuffix: '년',
      monthSuffix: '월',
      daySuffix: '일',
    },
    displayText: '년·월·일',
  },
  {
    type: 'SEPARATOR',
    value: '',
    displayText: '구분 기호 없이',
  },
];

export const DATE_FORMAT_OPTIONS = [
  { value: ['YYYY', 'MM', 'DD'] as const, displayText: 'YYYYMMDD' },
  { value: ['DD', 'MM', 'YYYY'] as const, displayText: 'DDMMYYYY' },
  { value: ['MM', 'DD', 'YYYY'] as const, displayText: 'MMDDYYYY' },
  { value: ['YYYY', 'DD', 'MM'] as const, displayText: 'YYYYDDMM' },
  { value: ['YY', 'MM', 'DD'] as const, displayText: 'YYMMDD' },
  { value: ['DD', 'MM', 'YY'] as const, displayText: 'DDMMYY' },
  { value: ['MM', 'DD', 'YY'] as const, displayText: 'MMDDYY' },
  { value: ['YY', 'DD', 'MM'] as const, displayText: 'YYDDMM' },
];
export type DateFormatValue = (typeof DATE_FORMAT_OPTIONS)[number]['value'];

export const FONT_POINT_OPTIONS = FONT_SIZES.map((size) => ({
  value: size,
  displayText: `${size}pt`,
}));
export const FONT_TYPE_OPTIONS = SELECTABLE_FONT_TYPE.map((type) => ({
  value: type,
  displayText: FONT_TYPES_MAP[type],
}));
